export const isBeta = (navListItem) => {
    return navListItem.isBeta;
};

export const isNew = (navListItem) => {
    return navListItem.isNew;
};

const isHideSidebarLockedFeaturesTest = false; // TODO: remove this when cleanup lnx-87-hide-sidebar-locked-features test

export const reduceSidebarLockedFeaturesTest = (acc, curr) => {
    if (!isHideSidebarLockedFeaturesTest) {
        return [...acc, curr];
    }

    if (curr.lockIcon) {
        return acc;
    }

    const subItems = curr?.subItems || [];

    const filteredSubItems = subItems.filter((subItem) => !subItem?.lockIcon || subItem?.upsellBadgeComponent);

    return !filteredSubItems.length
        ? filteredSubItems.length === subItems.length
            ? [...acc, curr]
            : acc
        : [...acc, { ...curr, subItems: filteredSubItems }];
};
